const countryCode = navigator.language.split('-')[1] || 'US'

/**
 * 获取国家代码
 * @returns 国家代码
 */
export const getCountryCode = () => {
  return countryCode
}
